import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  OnInit,
  inject,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FieldType, FieldTypeConfig, FormlyFieldConfig } from '@ngx-formly/core';
import { RadioState } from '@voyagu/portal-design-system';

import { Option } from '@app/forms/formly/formly-utils';

@Component({
  selector: 'radio-field',
  templateUrl: './radio-field.component.html',
  styleUrls: ['./radio-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RadioFieldComponent
  extends FieldType<FieldTypeConfig<FormlyFieldConfig['props'] & { options: Option[] }>>
  implements OnInit
{
  changeDetectorRef = inject(ChangeDetectorRef);
  destroyRef = inject(DestroyRef);

  ngOnInit() {
    this.formControl.events
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.changeDetectorRef.markForCheck());
  }

  get radioState(): RadioState {
    if (this.formControl.disabled) {
      return 'disabled';
    }

    if (this.showError) {
      return 'error';
    }

    return 'default';
  }

  onSelect(value: Option['value']) {
    this.formControl.markAsTouched();
    this.formControl.setValue(value);
    this.formControl.markAsDirty();
  }

  optionDescription(option: Option): string | undefined {
    const description = option.extra?.['description'];
    return typeof description === 'string' ? description : undefined;
  }
}
